{
  "cms.richText.action.blockquote": "Lainaus",
  "cms.richText.action.bold": "Lihavoi",
  "cms.richText.action.bulletList": "Luettelo",
  "cms.richText.action.clearFormat": "Poista muotoilut",
  "cms.richText.action.color": "Tekstin väri",
  "cms.richText.action.heading1": "Otsikko 1",
  "cms.richText.action.heading2": "Otsikko 2",
  "cms.richText.action.heading3": "Otsikko 3",
  "cms.richText.action.image": "Lisää kuva",
  "cms.richText.action.italic": "Kursivoi",
  "cms.richText.action.link": "Lisää linkki",
  "cms.richText.action.orderedList": "Numeroitu luettelo",
  "cms.richText.action.redo": "Tee uudelleen",
  "cms.richText.action.underline": "Alleviivaa",
  "cms.richText.action.undo": "Kumoa",
  "cms.richText.action.video": "Lisää video",
  "cms.richText.color.black": "Musta",
  "cms.richText.color.deepTeal": "Tumma turkoosi",
  "cms.richText.color.green": "Vihreä",
  "cms.richText.color.lightGreen": "Vaalea vihreä",
  "cms.richText.color.menu": "Värivalikko",
  "cms.richText.color.remove": "Poista väri",
  "cms.richText.color.teal": "Turkoosi",
  "cms.richText.dialog.cancel": "Peruuta",
  "cms.richText.dialog.image.title": "Lisää kuva",
  "cms.richText.dialog.image.urlLabel": "Kuvan URL-osoite",
  "cms.richText.dialog.insert": "Lisää",
  "cms.richText.dialog.link.title": "Lisää linkki",
  "cms.richText.dialog.link.urlLabel": "URL-osoite",
  "cms.richText.dialog.upload": "Lataa omalta koneelta",
  "cms.richText.dialog.video.title": "Lisää video",
  "cms.richText.dialog.video.urlLabel": "Videon URL-osoite",
  "cms.richText.loading": "Ladataan editoria…",
  "cms.richText.placeholder": "Aloita kirjoittaminen…",
  "cms.richText.toolbar.label": "Muotoiluvalikko"
}
